var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransportationGuideIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52607",
    "data-name": "Group 52607",
    transform: "translate(-712 -3004.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_91042",
    "data-name": "Path 91042",
    transform: "translate(712 3004.968)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0H64A20,20,0,0,1,84,20V64A20,20,0,0,1,64,84H20A20,20,0,0,1,0,64V20A20,20,0,0,1,20,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 1 C 17.43457794189453 1 14.94641876220703 1.502220153808594 12.60465240478516 2.492698669433594 C 10.34226989746094 3.449607849121094 8.310218811035156 4.819725036621094 6.564979553222656 6.564979553222656 C 4.819725036621094 8.310218811035156 3.449607849121094 10.34226989746094 2.492698669433594 12.60465240478516 C 1.502220153808594 14.94641876220703 1 17.43457794189453 1 20 L 1 64 C 1 66.56542205810547 1.502220153808594 69.05357360839844 2.492698669433594 71.39534759521484 C 3.449607849121094 73.65773010253906 4.819725036621094 75.68977355957031 6.564979553222656 77.43502044677734 C 8.310218811035156 79.18027496337891 10.34226989746094 80.55039215087891 12.60465240478516 81.50730133056641 C 14.94641876220703 82.49777984619141 17.43457794189453 83 20 83 L 64 83 C 66.56542205810547 83 69.05357360839844 82.49777984619141 71.39534759521484 81.50730133056641 C 73.65773010253906 80.55039215087891 75.68977355957031 79.18027496337891 77.43502044677734 77.43502044677734 C 79.18027496337891 75.68977355957031 80.55039215087891 73.65773010253906 81.50730133056641 71.39534759521484 C 82.49777984619141 69.05357360839844 83 66.56542205810547 83 64 L 83 20 C 83 17.43457794189453 82.49777984619141 14.94641876220703 81.50730133056641 12.60465240478516 C 80.55039215087891 10.34226989746094 79.18027496337891 8.310218811035156 77.43502044677734 6.564979553222656 C 75.68977355957031 4.819725036621094 73.65773010253906 3.449607849121094 71.39534759521484 2.492698669433594 C 69.05357360839844 1.502220153808594 66.56542205810547 1 64 1 L 20 1 M 20 0 L 64 0 C 75.04568481445312 0 84 8.954307556152344 84 20 L 84 64 C 84 75.04568481445312 75.04568481445312 84 64 84 L 20 84 C 8.954307556152344 84 0 75.04568481445312 0 64 L 0 20 C 0 8.954307556152344 8.954307556152344 0 20 0 Z",
    stroke: "none",
    fill: "#93a750"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(702.614 3016.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52545",
    "data-name": "Group 52545",
    transform: "translate(24.025 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91043",
    "data-name": "Path 91043",
    d: "M215.975,90H237.3v3.554H215.975Z",
    transform: "translate(-193.237 -79.339)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91044",
    "data-name": "Path 91044",
    d: "M32.957,359.12l-7.891,7.891a3.554,3.554,0,0,0,0,5.026h0a3.554,3.554,0,0,0,5.026,0l7.8-7.8A14.3,14.3,0,0,1,32.957,359.12Z",
    transform: "translate(-24.025 -316.579)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 10.661,
    cy: 10.661,
    r: 10.661,
    transform: "translate(10.642 24.876)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91045",
    "data-name": "Path 91045",
    d: "M125.975,0V24.723A14.215,14.215,0,1,1,131.25,49.2l-5.275,5.275v5.94H168.62V0Zm35.537,53.306H147.3V49.752h14.215Zm0-7.107H154.4V42.645h7.107Zm0-7.107H154.4V35.537h7.107Zm0-7.107H154.4V28.43h7.107Zm0-7.107H150.143V21.322h11.369v3.554Zm0-7.107h-28.43V7.107h28.43Z",
    transform: "translate(-113.898 0)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportationGuideIcon);
export default __webpack_public_path__ + "static/media/TransportationGuideIcon.05ee695b59dba78086ad0ec89ce6c2cf.svg";
export { ForwardRef as ReactComponent };